"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
var i18next_icu_1 = __importDefault(require("i18next-icu"));
var react_i18next_1 = require("react-i18next");
var wrapT_1 = __importDefault(require("../../utils/wrapT"));
var i18next_browser_languagedetector_1 = __importDefault(require("i18next-browser-languagedetector"));
var i18next_xhr_backend_1 = __importDefault(require("i18next-xhr-backend"));
var i18next_1 = __importDefault(require("i18next"));
var globalizeTranslations_1 = require("../../utils/globalizeTranslations");
exports.default = (function (_a, scopedI18next) {
    var languageCode = _a.languageCode, disableAutoDetect = _a.disableAutoDetect, useXhr = _a.useXhr, xhrCacheId = _a.xhrCacheId, translations = _a.translations, fallbackLanguages = _a.fallbackLanguages, formats = _a.formats, whitelist = _a.whitelist, bindTranslationsToWindow = _a.bindTranslationsToWindow;
    var scopedOrGlobalI18next = scopedI18next || i18next_1.default;
    [
        [new i18next_icu_1.default(), true],
        [i18next_browser_languagedetector_1.default, !languageCode && !disableAutoDetect],
        [i18next_xhr_backend_1.default, useXhr],
        [react_i18next_1.initReactI18next, !scopedI18next]
    ].filter(function (_a) {
        var plugin = _a[0], enabled = _a[1];
        return enabled;
    })
        .map(function (_a) {
        var plugin = _a[0];
        return plugin;
    })
        .forEach(function (plugin) { return scopedOrGlobalI18next.use(plugin); });
    return scopedOrGlobalI18next.init({
        resources: useXhr ? undefined : (translations || {}),
        lng: languageCode,
        fallbackLng: fallbackLanguages,
        detection: {
            order: ['navigator', 'htmlTag'],
        },
        i18nFormat: {
            formats: formats
        },
        interpolation: {
            escapeValue: false
        },
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json?v=' + (xhrCacheId || Date.now().valueOf())
        },
        whitelist: whitelist
    }).then(function (t) {
        if (bindTranslationsToWindow) {
            globalizeTranslations_1.bindTransToWindow(t);
        }
        return wrapT_1.default(t);
    });
});
